import { fmtGram } from "@/lib/format";

// breakdown: [{ karat, gram, has(pure) }]
export default function GramSummary({ breakdown = [], totalPureHas = 0, totalIscHas = 0, totalHas = 0, testid, estimated = false }) {
  return (
    <div data-testid={testid} className="bg-surface border border-border rounded-md p-4">
      <div className="text-[10px] tracking-luxe uppercase text-gold mb-3">Sipariş Özeti · Has Altın{estimated ? " (Tahmini)" : ""}</div>
      <div className="space-y-2">
        {breakdown.map((b) => (
          <div key={b.karat} className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">{b.karat} Ayar</span>
            <span className="text-foreground font-medium">
              {fmtGram(b.gram)} gr
              <span className="text-muted-foreground font-normal"> · saf {fmtGram(b.has)} gr</span>
            </span>
          </div>
        ))}
      </div>
      <div className="border-t border-border mt-3 pt-3 space-y-2">
        <div className="flex justify-between text-sm">
          <span className="text-muted-foreground">Saf Has Altın</span>
          <span className="text-foreground">{fmtGram(totalPureHas)} gr</span>
        </div>
        <div className="flex justify-between text-sm">
          <span className="text-muted-foreground">İşçilik (Has)</span>
          <span className="text-foreground">{fmtGram(totalIscHas)} gr</span>
        </div>
        <div className="flex justify-between items-center pt-2 border-t border-border">
          <span className="text-sm text-muted-foreground">{estimated ? "Tahmini Toplam Has Altın" : "Toplam Has Altın"}</span>
          <span data-testid="total-has" className="text-xl font-semibold text-gold">{fmtGram(totalHas)} gr</span>
        </div>
      </div>
      {estimated && (
        <p className="text-[11px] text-amber-400/90 mt-3 leading-snug">
          Gramlar tahminidir. Kesin has altın, ürünler üretilip gerçek gramları belirlendikten sonra hesaplanır.
        </p>
      )}
    </div>
  );
}
